import toast from "react-hot-toast";
import useRead from "../../useRead";

const useGetSalaryComponent = ({ componentId, onSuccess }) => {
  const { list } = useRead({
    url: "salary-components/fetchSingle",
    method: "GET",
    initialData: { component_id: componentId },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      toast.error("Error fetching salary component: " + error.message);
    },
  });

  const isDataLoading = list.isLoading;

  return {
    isDataLoading,
  };
};

export default useGetSalaryComponent;
